import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RaisePassRequestComponent } from '../person-on-board/components/raise-pass-request/raise-pass-request.component';
import { PassRequestsDashboardComponent } from './components/pass-requests-dashboard/pass-requests-dashboard.component';
import { PobListDashboardComponent } from './components/pob-list-dashboard/pob-list-dashboard.component';
import { ViewPassRequestComponent } from './components/view-pass-request/view-pass-request.component';
import { CheckinOutComponent } from './components/checkin-out/checkin-out.component';
const routes: Routes = [

  {
    path: 'raise-passrequest/:passId',
    component: RaisePassRequestComponent
  },
  {
    path: 'pass-request-overview',
    component: PassRequestsDashboardComponent
  },
  {
    path: 'pob-list-overview',
    component: PobListDashboardComponent
  },
  {
    path: 'view-pass-request/:passId',
    component: ViewPassRequestComponent
  },
  {
    path: 'check-in-out',
    component: CheckinOutComponent
  }

];
@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule],
})
export class PersononboardRoutingModule { }
